_ = require("lodash")

class CourseFilterCtrl
  selectedCourse: undefined

  constructor: (@$scope) ->
    @$scope.$on "coursesUpdated.gnp.analysis", (event, courses) =>
      @courses = courses
      cachedCourse = localStorage.getItem("ANALYSIS_SELECTED_COURSE")
      if !(cachedCourse && cachedCourse != 'undefined')
        #ng-repeat will generate the new $$hashId, so that we need to track the selected course again.
        @_refreshSelectedCourse()
        @$scope.$emit 'courseChanged.gnp.analysis', @selectedCourse

    @$scope.$watch (=> @courses), (courses) =>
      cachedCourse = localStorage.getItem("ANALYSIS_SELECTED_COURSE")
      if cachedCourse && cachedCourse != 'undefined'
        @selectedCourse = _.find courses, (c) =>
          c.id is cachedCourse
        if @selectedCourse
          @$scope.$emit 'courseChanged.gnp.analysis', @selectedCourse

  _refreshSelectedCourse: ->
    return unless @selectedCourse
    @selectedCourse = _.find @courses, (c) =>
      c.course.ext_id is @selectedCourse.course.ext_id

  selectCourse: (course) ->
    return unless @$scope.$root.paid
    @selectedCourse = if @selectedCourse is course then undefined else course
    if course
      localStorage.setItem("ANALYSIS_SELECTED_COURSE", course.id)
    @$scope.$emit 'courseChanged.gnp.analysis', @selectedCourse

CourseFilterCtrl.$inject = [
  '$scope'
]

module.exports = CourseFilterCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/course-filter/course-filter-controller.coffee